<template>
  <div class="outdated-paid-refunded">
    <div class="subpage-header">
      <h2 class="normal" id="page-title-for-sr">
        <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
        <span aria-live="assertive" role="status" v-html="$t('confirmation.outdatedPaidRefunded.header')"></span>
      </h2>
    </div>
    <p v-html="$t('confirmation.outdatedPaidRefunded.description')"></p><p v-html="$t('confirmation.outdatedPaidRefunded.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationOutdatedPaidRefunded'
}
</script>
